export default "<svg viewBox=\"0 0 12 5\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M12 0H0L6.24658 5L12 0Z\" fill=\"#A5A5A5\"/>\n</svg>\n"